// extracted by mini-css-extract-plugin
export default {"teamMember":"AboutTeam_teamMember__QB5Se","aboutTeam":"AboutTeam_aboutTeam__jFBFg"};